import { css } from 'styled-components';
import { COLORS } from '../../design/tokens';

const styles = {
  container: css`
    width: ${({ width }) => width};
    height: ${({ height }) => height || 'auto'};
    border: 1px solid ${COLORS.SECTION.BORDER};
    border-radius: 2px;
    background-color: ${COLORS.SECTION.BACKGROUND};
    margin-bottom: 20px;
  `
};

export default styles;
